import client_lookups from '@/assets/json/clientLookups.json'
import { useAuthStore } from '@/stores/auth'
/**
 * expected param: {
 *   requestNumber: String,
 *   allowedRefundMethodIds: Array
 * }
 * @returns
 */
async function parseRefundMethods({ allowedRefundMethodIds: options }) {
  if ((options || []).length === 0) return []
  const { refundMethodTypes, establishmentApplicationId } = client_lookups

  const authStore = useAuthStore()
  const applicationId = authStore.user.applicationId

  options = options.filter((o) => o > 0)

  /**
   * filter out iban method for establishments
   * cancelSubscriptionCtrl.js ln174
   */
  // if (applicationId == establishmentApplicationId) {
  //   options = options.filter((o) => o != refundMethodTypes.iban)
  // }

  Object.entries(refundMethodTypes).filter((rt) => rt)

  const output = Object.entries(refundMethodTypes)
    .filter(([__, value]) => value > 0)
    .filter(([__, value]) => options.includes(value))
    .map(([label, value]) => ({ label, value }))

  return output
}

export default function () {
  return {
    parseRefundMethods
  }
}
